import React from 'react';
import MainContent from '../components/MainContent/MainContent';

// Mock product data for demonstration purposes. In a real application, this would come from an API call.
const mockProducts = [
  { 
    id: 1, 
    name: "Forfait spécial dévcouverte", 
    logoUrl: "/icone.jpg", // Placeholder logo path
    description: ["experience de 2h a la découverte des chevaux", "Contact privilégié en petit groupe", "Parfait pour les non initiés a l'équitation", "parfait pour se mettre en confiance","2h avec les chevaux dont 30-45 mins à cheval dans la nature"  ], 
    minPrice: { amount: 30, unit: "booking" }
  },
  { 
    id: 2, 
    name: "balade a la carte", 
    logoUrl: "/icone.jpg", // Placeholder logo path
    description: ["De 1h a 2h30 de balade a cheval", "Allure selon le niveau","accessible au non initiés pour 1h","nombreux chemins de balade dans la nature", "parfait pour les cavaliers qui veulent se faire plaisir et se balader dans la nature" ], 
    minPrice: { amount: 40, unit: "booking" }
  },
  { 
    id: 3, 
    name: "A la journée", 
    logoUrl: "/icone.jpg", // Placeholder logo path
    description: ["Randonnée sur la journée avec pause déjeuner","à l'aise aux trois allures ou sportifs", "Pique-nique issue de produit locaux en option", "Pour cavaliers avec un minimum d'expérience", ], 
    minPrice: { amount: 100, unit: "booking" }
  },
  { 
    id: 4, 
    name: "plusieurs jours", 
    logoUrl: "/icone.jpg", // Placeholder logo path
    description: ["Randonnée sur plusieurs jours", "En bivouac ou en gite selon les envies", "Pour cavaliers a l'aise aux trois allures ou sportifs "], 
    minPrice: { amount: 125, unit: "day" }
  }
];

const PrestationsPage: React.FC = () => {
  return (
    <>
      <MainContent products={mockProducts} />
    </>
  );
};

export default PrestationsPage;